import Store from '@store';

export class TextMockFactory {
  #store;

  constructor () {
    this.#store = Store;
  }

  #createTextMock () {
    const textMockSvg = document.createElementNS(svgedit.NS.SVG, 'svg');
    textMockSvg.setAttribute('xml:space', 'preserve');
    textMockSvg.setAttribute('id', 'textmock');
    textMockSvg.setAttribute('width', 0);

    document.body.append(textMockSvg);
    return textMockSvg;
  }

  getTextMock () {
    return document.getElementById('textmock') || this.#createTextMock();
  }

  emptyTextMock () {
    const node = document.getElementById('textmock');
    if (!node) return;

    while (node.firstChild) {
      node.firstChild.remove();
    }
  }

  removeElementsFromTextMock (pageId) {
    const textMock = this.getTextMock();

    textMock.querySelectorAll(`[data-page-id="${pageId}"], [data-page-id="${INKIVE.Tool._current_design_id}"]`)
      .forEach(element => element.remove());
  }

  addElementsToTextMock (pageId, textElements, onElementAdded) {
    if (pageId === INKIVE.Tool._current_design_id) return;

    const textMock = this.getTextMock();
    this.removeElementsFromTextMock(pageId);

    for (const element of textElements) {
      if (element.pageId === INKIVE.Tool._current_design_id) continue;

      textMock.insertAdjacentHTML('beforeend', element.nodeString);

      const node = textMock.lastChild;
      node.dataset.pageId = pageId;

      onElementAdded?.(node, element);
    }
  }
}

export const getTextMockInstance = (() => {
  let instance = null;

  return () => {
    if (!instance) {
      instance = new TextMockFactory();
    }

    return instance;
  };
})();
